import React, { useEffect } from 'react';

interface ExternalRedirectProps {
  url: string;
}

const ExternalRedirect: React.FC<ExternalRedirectProps> = ({ url }) => {
  useEffect(() => {
    // @ts-ignore
    window.location = url;
  }, [url]);
  return <div style={{ padding: '3em' }}>Redirecting to ... {url}</div>;
};

export default ExternalRedirect;
